export enum TimelineGridCurrentTimeIndicatorCssVars {
  xPosition = '--x-position',
}
